import ExcelJS from 'exceljs';
import moment from 'moment-timezone';
import { styleHeader, styleHeaderDateRange, styleColumnWidth, downloadExcel } from './helper/helperExportExcelInvoice';

/*
7605b08e-0d3f-4a16-9b2b-eff3b1bce92e    Service Charge
0fa1c0f1-917a-487d-bac2-c8328288cefd    Listrik
d4ebbc89-1bc0-4135-936e-94783e2304b5    Sewa Permanen
3460ce8e-3e4e-47d6-8141-9a4d8a8d7775    Air
1351a038-79b5-4625-b4ee-6373b1e47cf0    Sewa Temporary/Pameran
*/

export const exportExcelInvoice = async (
    nameFile: string,
    data: any[],
    selectTemplateIdPipeline: string,
    dateRange?: [Date, Date] | null
) => {
    try {
        const sanitizedNameFile = nameFile.replace(/[/\\?%*:|"<>]/g, '-');

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(sanitizedNameFile);
        if (selectTemplateIdPipeline === 'd4ebbc89-1bc0-4135-936e-94783e2304b5') {
            const headers = ['Tanggal Di buat No Invoice', 'No Invoice', 'Nama Tenant', 'No Unit', 'Keterangan', 'Telepon', 'Nominal Bruto', 'Nominal PPN', 'Nominal Total', 'No KTP', 'No NPWP', 'Alamat', 'No Faktur', 'Attachment']
            // const subHeaders = ['Tanggal Di buat No Invoice', 'No Invoice', 'Nama Tenant', 'Custom Field - No Unit', 'Keterangan', 'Progress' ,'Telepon', 'Nominal DPP', 'Nominal PPN', 'Nominal Total', 'No KTP', 'No NPWP', 'Alamat', 'No Faktur', 'Attachment']
            if (dateRange) {
                const dateRangeRow = worksheet.addRow(['Tanggal Export : ' + moment(dateRange[0]).format('DD MMM YYYY') + ' - ' + moment(dateRange[1]).format('DD MMM YYYY')])
                styleHeaderDateRange(worksheet, dateRangeRow);
            }
            worksheet.addRow(headers);
            // worksheet.addRow(subHeaders);
            const checkDateRange = dateRange ? true : false;
            styleHeader(worksheet, checkDateRange ? 2 : 1, 'F6991D', false);
            // styleHeader(worksheet, checkDateRange ? 3 : 2, 'FFE699', true);

            let totalNominalDPP = 0;
            let totalNominalPPN = 0;
            let totalNominalTotal = 0;

            data.forEach(item => {
                const row = worksheet.addRow([
                    moment.utc(item['startDate']).format('DD MMM YYYY') || '-',
                    item['No. Invoice'] || '-',
                    item.merchantName || '-', // Merchant Name
                    item['No Unit'] || '-',
                    item.description || '-',
                    item.merchantPhone || '-',
                    Math.round(item.nominalDPP || 0),
                    Math.round(item.nominalPPN || 0),
                    Math.round(item.nominalTotal || 0),
                    item['No KTP'] || '-',
                    item['No NPWP'] || '-',
                    item['Alamat'] || '-',
                    item['No Faktur'] || '-',
                    item['attacmentDoc'] || '-',
                ]);

                totalNominalDPP += Math.round(item.nominalDPP || 0);
                totalNominalPPN += Math.round(item.nominalPPN || 0);
                totalNominalTotal += Math.round(item.nominalTotal || 0);

                row.eachCell((cell, colNumber) => {
                    cell.alignment = { vertical: 'middle', wrapText: true };

                    // Format numbers untuk kolom nominal
                    if (colNumber === 7 || colNumber === 8 || colNumber === 9) {
                        cell.numFmt = '#,##0;[Red]-#,##0';
                        cell.alignment.horizontal = 'right';
                    }
                });
            });

            // Add total row for Sewa Permanen template (columns 7, 8, 9)
            const totalRow = worksheet.addRow([
                'Total',
                '',
                '',
                '',
                '',
                '',
                totalNominalDPP,
                totalNominalPPN,
                totalNominalTotal,
                '',
                '',
                '',
                '',
                ''
            ]);

            // Style the total row
            totalRow.eachCell((cell, colNumber) => {
                cell.font = { bold: true };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFE699' }
                };

                if (colNumber === 7 || colNumber === 8 || colNumber === 9) {
                    cell.numFmt = '#,##0;[Red]-#,##0';
                    cell.alignment = { horizontal: 'right', vertical: 'middle' };
                } else {
                    cell.alignment = { vertical: 'middle', wrapText: true };
                }
            });

            styleColumnWidth(worksheet, 30, [28, 34, 20, 20, 20, 15, 25, 20, 15, 15, 15, 15, 15, 15]);
            await downloadExcel(workbook, nameFile, dateRange);
        } else if (selectTemplateIdPipeline === '1351a038-79b5-4625-b4ee-6373b1e47cf0') {
            const headers = ['Tanggal Di buat No Invoice', 'No Invoice', 'Nama Tenant', 'No Unit', 'Keterangan', 'Telepon', 'Nominal', 'PPN', 'NETTO', 'KTP', 'NPWP', 'Alamat', 'No Faktur', 'Attachment']
            // const subHeaders = ['No Invoice', 'Nama Tenant', 'Custom Field - No Unit', 'Keterangan', 'Telepon', 'Nominal Termin', 'Nominal Pipeline', 'Produk', 'Sumber', 'Custom Field - Jangka Waktu Sewa', 'Custom Field - Periode Start Sewa', 'Custom Field - Periode Berakhir Sewa', 'Custom Field - Nilai Jaminan', 'Attachment']
            if (dateRange) {
                const dateRangeRow = worksheet.addRow(['Tanggal Export : ' + moment(dateRange[0]).format('DD MMM YYYY') + ' - ' + moment(dateRange[1]).format('DD MMM YYYY')])
                styleHeaderDateRange(worksheet, dateRangeRow);
            }
            worksheet.addRow(headers);
            // worksheet.addRow(subHeaders);

            const checkDateRange = dateRange ? true : false;
            styleHeader(worksheet, checkDateRange ? 2 : 1, 'F6991D', false);
            // styleHeader(worksheet, checkDateRange ? 3 : 2, 'FFE699', true);

            let totalNominalDPP = 0;
            let totalNominalPPN = 0;
            let totalNominalTotal = 0;

            data.forEach(item => {
                const row = worksheet.addRow([
                    moment.utc(item['startDate']).format('DD MMM YYYY') || '-',
                    item['No. Invoice'] || '-',
                    item.merchantName || '-', // Merchant Name
                    item['No Unit'] || '-',
                    item.description || '-',        // Keterangan
                    item.merchantPhone || '-',            // Telepon
                    Math.round(item.nominalDPP || 0),
                    Math.round(item.nominalPPN || 0),
                    Math.round(item.nominalTotal || 0),
                    item['No KTP'] || '-',
                    item['No NPWP'] || '-',
                    item['Alamat'] || '-',
                    item['No Faktur'] || '-',
                    item['attacmentDoc'] || '-'
                ]);

                totalNominalDPP += Math.round(item.nominalDPP || 0);
                totalNominalPPN += Math.round(item.nominalPPN || 0);
                totalNominalTotal += Math.round(item.nominalTotal || 0);

                row.eachCell((cell, colNumber) => {
                    cell.alignment = { vertical: 'middle', wrapText: true };

                    // Format numbers untuk kolom nominal
                    if (colNumber === 7 || colNumber === 8 || colNumber === 9) {
                        cell.numFmt = '#,##0;[Red]-#,##0';
                        cell.alignment.horizontal = 'right';
                    }
                });
            });

            // Add total row for Sewa Temporary template (columns 7, 8, 9)
            const totalRow = worksheet.addRow([
                'Total',
                '',
                '',
                '',
                '',
                '',
                totalNominalDPP,
                totalNominalPPN,
                totalNominalTotal,
                '',
                '',
                '',
                '',
                ''
            ]);

            // Style the total row
            totalRow.eachCell((cell, colNumber) => {
                cell.font = { bold: true };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFE699' }
                };

                if (colNumber === 7 || colNumber === 8 || colNumber === 9) {
                    cell.numFmt = '#,##0;[Red]-#,##0';
                    cell.alignment = { horizontal: 'right', vertical: 'middle' };
                } else {
                    cell.alignment = { vertical: 'middle', wrapText: true };
                }
            });

            styleColumnWidth(worksheet, 30, [28, 34, 20, 20, 20, 15, 25, 20, 15, 15, 15, 15, 15, 15]);
            await downloadExcel(workbook, nameFile, dateRange);
        } else if (selectTemplateIdPipeline === '7605b08e-0d3f-4a16-9b2b-eff3b1bce92e') {
            const headers = ['Tanggal Di buat No Invoice', 'No Invoice', 'Nama Tenant', 'No Unit', 'Keterangan', 'Telepon', 'Nominal Bruto', 'PPN', 'NETTO', 'KTP', 'NPWP', 'Alamat', 'No Faktur', 'Attachment']
            // const subHeaders = ['No Invoice', 'Nama Tenant', 'Custom Field - No Unit', 'Keterangan', 'Progres', 'Telepon', 'Nominal Pipeline', 'Produk', 'Sumber', 'Custom Field - Periode Penagihan', 'Custom Field - Jatuh Tempo', 'Attachment']
            if (dateRange) {
                const dateRangeRow = worksheet.addRow(['Tanggal Export : ' + moment(dateRange[0]).format('DD MMM YYYY') + ' - ' + moment(dateRange[1]).format('DD MMM YYYY')])
                styleHeaderDateRange(worksheet, dateRangeRow);
            }
            worksheet.addRow(headers);
            // worksheet.addRow(subHeaders);
            const checkDateRange = dateRange ? true : false;
            styleHeader(worksheet, checkDateRange ? 2 : 1, 'F6991D', false);
            // styleHeader(worksheet, checkDateRange ? 3 : 2, 'FFE699', true);

            let totalNominalDPP = 0;
            let totalNominalPPN = 0;
            let totalNominalTotal = 0;

            data.forEach(item => {
                const row = worksheet.addRow([
                    moment.utc(item['startDate']).format('DD MMM YYYY') || '-',
                    item['No. Invoice'] || '-',
                    item.merchantName || '-', // Merchant Name
                    item['No Unit'] || '-',
                    item.description || '-',        // Keterangan
                    item.merchantPhone || '-',            // Telepon
                    Math.round(item.nominalDPP || 0),
                    Math.round(item.nominalPPN || 0),
                    Math.round(item.nominalTotal || 0),
                    item['No KTP'] || '-',
                    item['No NPWP'] || '-',
                    item['Alamat'] || '-',
                    item['No Faktur'] || '-',
                    item['attacmentDoc'] || '-'
                ]);

                totalNominalDPP += Math.round(item.nominalDPP || 0);
                totalNominalPPN += Math.round(item.nominalPPN || 0);
                totalNominalTotal += Math.round(item.nominalTotal || 0);

                row.eachCell((cell, colNumber) => {
                    cell.alignment = { vertical: 'middle', wrapText: true };

                    // Format numbers untuk kolom nominal
                    if (colNumber === 7 || colNumber === 8 || colNumber === 9) {
                        cell.numFmt = '#,##0;[Red]-#,##0';
                        cell.alignment.horizontal = 'right';
                    }
                });
            });

            // Add total row for Service Charge template (columns 7, 8, 9)
            const totalRow = worksheet.addRow([
                'Total',
                '',
                '',
                '',
                '',
                '',
                totalNominalDPP,
                totalNominalPPN,
                totalNominalTotal,
                '',
                '',
                '',
                '',
                ''
            ]);

            // Style the total row
            totalRow.eachCell((cell, colNumber) => {
                cell.font = { bold: true };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFE699' }
                };

                if (colNumber === 7 || colNumber === 8 || colNumber === 9) {
                    cell.numFmt = '#,##0;[Red]-#,##0';
                    cell.alignment = { horizontal: 'right', vertical: 'middle' };
                } else {
                    cell.alignment = { vertical: 'middle', wrapText: true };
                }
            });

            styleColumnWidth(worksheet, 30, [28, 34, 20, 20, 20, 15, 25, 20, 15, 15, 15, 15, 15, 15]);
            await downloadExcel(workbook, nameFile, dateRange);
        } else if (selectTemplateIdPipeline === '0fa1c0f1-917a-487d-bac2-c8328288cefd') {
            const headers = ['Tanggal Di buat No Invoice', 'No Invoice', 'Nama Tenant', 'No Unit', 'Keterangan', 'Progress', 'Telepon', 'DPP', 'PPN', 'NETTO', 'KTP', 'NPWP', 'Alamat', 'No Faktur', 'Attachment']
            // const subHeaders = ['No Invoice', 'Nama Tenant', 'Custom Field - No Unit', 'Keterangan', 'Progres', 'Telepon', 'Nominal Pipeline', 'Produk', 'Sumber', 'Custom Field - Periode Penagihan', 'Custom Field - Periode Start Pemakaian', 'Custom Field - Periode Berakhir Pemakaian', 'Custom Field - Tanggal Jatuh Tempo', 'Custom Field - Faktor Meter', 'Custom Field - Daya', 'Custom Field - Meter Lalu', 'Custom Field - Meter Akhir', 'Attachment Doc inv']
            if (dateRange) {
                const dateRangeRow = worksheet.addRow(['Tanggal Export : ' + moment(dateRange[0]).format('DD MMM YYYY') + ' - ' + moment(dateRange[1]).format('DD MMM YYYY')])
                styleHeaderDateRange(worksheet, dateRangeRow);
            }
            worksheet.addRow(headers);
            // worksheet.addRow(subHeaders);
            const checkDateRange = dateRange ? true : false;
            styleHeader(worksheet, checkDateRange ? 2 : 1, 'F6991D', false);
            // styleHeader(worksheet, checkDateRange ? 3 : 2, 'FFE699', true);

            let totalNominalDPP = 0;
            let totalNominalPPN = 0;
            let totalNominalTotal = 0;

            data.forEach(item => {
                const row = worksheet.addRow([
                    moment.utc(item['startDate']).format('DD MMM YYYY') || '-',
                    item['No. Invoice'] || '-',
                    item.merchantName || '-', // Merchant Name
                    item['No Unit'] || '-',
                    item.description || '-',        // Keterangan
                    item.progress || '-',
                    item.merchantPhone || '-',            // Telepon
                    Math.round(item.nominalDPP || 0),
                    Math.round(item.nominalPPN || 0),
                    Math.round(item.nominalTotal || 0),
                    item['No KTP'] || '-',
                    item['No NPWP'] || '-',
                    item['Alamat'] || '-',
                    item['No Faktur'] || '-',
                    item['attacmentDoc'] || '-'
                ]);

                totalNominalDPP += Math.round(item.nominalDPP || 0);
                totalNominalPPN += Math.round(item.nominalPPN || 0);
                totalNominalTotal += Math.round(item.nominalTotal || 0);

                row.eachCell((cell, colNumber) => {
                    cell.alignment = { vertical: 'middle', wrapText: true };

                    // Format numbers untuk kolom nominal
                    if (colNumber === 8 || colNumber === 9 || colNumber === 10) {
                        cell.numFmt = '#,##0;[Red]-#,##0';
                        cell.alignment.horizontal = 'right';
                    }
                });
            });

            // Add total row for Listrik template (columns 8, 9, 10)
            const totalRow = worksheet.addRow([
                'Total',
                '',
                '',
                '',
                '',
                '',
                '',
                totalNominalDPP,
                totalNominalPPN,
                totalNominalTotal,
                '',
                '',
                '',
                '',
                ''
            ]);

            // Style the total row
            totalRow.eachCell((cell, colNumber) => {
                cell.font = { bold: true };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFE699' }
                };

                if (colNumber === 8 || colNumber === 9 || colNumber === 10) {
                    cell.numFmt = '#,##0;[Red]-#,##0';
                    cell.alignment = { horizontal: 'right', vertical: 'middle' };
                } else {
                    cell.alignment = { vertical: 'middle', wrapText: true };
                }
            });

            styleColumnWidth(worksheet, 30, [28, 34, 20, 20, 20, 15, 25, 20, 15, 15, 15, 15, 15, 15]);
            await downloadExcel(workbook, nameFile, dateRange);
        } else if (selectTemplateIdPipeline === '3460ce8e-3e4e-47d6-8141-9a4d8a8d7775') {
            const headers = ['Tanggal Di buat No Invoice', 'No Invoice', 'Nama Tenant', 'No Unit', 'Keterangan', 'Progress', 'Telepon', 'Tagihan Air', 'DPP', 'PPN', 'NETTO', 'KTP', 'NPWP', 'Alamat', 'No Faktur', 'Attachment']
            // const subHeaders = ['No Invoice', 'Nama Tenant', 'Custom Field - No Unit', 'Keterangan', 'Progres', 'Telepon', 'Nominal Pipeline', 'Produk', 'Sumber', 'Custom Field - Periode Penagihan', 'Custom Field - Tanggal Jatuh Tempo', 'Custom Field - Tanggal Penunjukan Meter', 'Custom Field - Meter Lama', 'Custom Field - Meter Akhir', 'Attachment Doc inv']
            if (dateRange) {
                const dateRangeRow = worksheet.addRow(['Tanggal Export : ' + moment(dateRange[0]).format('DD MMM YYYY') + ' - ' + moment(dateRange[1]).format('DD MMM YYYY')])
                styleHeaderDateRange(worksheet, dateRangeRow);
            }
            worksheet.addRow(headers);
            // worksheet.addRow(subHeaders);
            const checkDateRange = dateRange ? true : false;
            styleHeader(worksheet, checkDateRange ? 2 : 1, 'F6991D', false);
            // styleHeader(worksheet, checkDateRange ? 3 : 2, 'FFE699', true);

            let totalTagihanAir = 0;
            let totalNominalDPP = 0;
            let totalNominalPPN = 0;
            let totalNominalTotal = 0;

            data.forEach(item => {
                const row = worksheet.addRow([
                    moment.utc(item['startDate']).format('DD MMM YYYY') || '-',
                    item['No. Invoice'] || '-',
                    item.merchantName || '-', // Merchant Name
                    item['No Unit'] || '-',
                    item.description || '-',        // Keterangan
                    item.progress || '-',
                    item.merchantPhone || '-',            // Telepon
                    Math.round(item.tagihanAir || 0),
                    Math.round(item.nominalDPP || 0),
                    Math.round(item.nominalPPN || 0),
                    Math.round(item.nominalTotal || 0),
                    item['No KTP'] || '-',
                    item['No NPWP'] || '-',
                    item['Alamat'] || '-',
                    item['No Faktur'] || '-',
                    item['attacmentDoc'] || '-'
                ]);

                totalTagihanAir += Math.round(item.tagihanAir || 0);
                totalNominalDPP += Math.round(item.nominalDPP || 0);
                totalNominalPPN += Math.round(item.nominalPPN || 0);
                totalNominalTotal += Math.round(item.nominalTotal || 0);

                row.eachCell((cell, colNumber) => {
                    cell.alignment = { vertical: 'middle', wrapText: true };

                    // Format numbers untuk kolom nominal
                    if (colNumber === 8 || colNumber === 9 || colNumber === 10 || colNumber === 11) {
                        cell.numFmt = '#,##0;[Red]-#,##0';
                        cell.alignment.horizontal = 'right';
                    }
                });
            });

            // Add total row for Air template (columns 8, 9, 10, 11)
            const totalRow = worksheet.addRow([
                'Total',
                '',
                '',
                '',
                '',
                '',
                '',
                totalTagihanAir,
                totalNominalDPP,
                totalNominalPPN,
                totalNominalTotal,
                '',
                '',
                '',
                '',
                ''
            ]);

            // Style the total row
            totalRow.eachCell((cell, colNumber) => {
                cell.font = { bold: true };
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: 'FFE699' }
                };

                if (colNumber === 8 || colNumber === 9 || colNumber === 10 || colNumber === 11) {
                    cell.numFmt = '#,##0;[Red]-#,##0';
                    cell.alignment = { horizontal: 'right', vertical: 'middle' };
                } else {
                    cell.alignment = { vertical: 'middle', wrapText: true };
                }
            });

            styleColumnWidth(worksheet, 30, [28, 34, 20, 20, 20, 15, 25, 20, 15, 15, 15, 15, 15, 15]);
            await downloadExcel(workbook, nameFile, dateRange);
        }
    } catch (error) {
        console.error('Error in exportExcelInvoice:', error);
        throw error;
    }
};
